export const getCurrentDate = () => {
  const today = new Date();
  return today.toISOString().split('T')[0];
};

// Calculate the date 10 days before today
export const getDateTenDaysAgo = () => {
  const date = new Date();
  date.setDate(date.getDate() - 10);
  return date.toISOString().split('T')[0];
};

// Format date for display (e.g., "October 30, 2025")
export const formatDateForDisplay = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });
};


//  ormat a timestamp into a short "time ago" string (e.g., '2d', '3h')
export const formatTimeAgo = (dateString) => {
  if (!dateString) return '';
  const then = new Date(dateString).getTime();
  const now = Date.now();
  const diff = Math.floor((now - then) / 1000); // seconds

  if (diff < 60) return `${diff}s`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
  return `${Math.floor(diff / 86400)}d`;
};


//Return the date string for N days before the given dateString (YYYY-MM-DD)
export const getDateBefore = (dateString, days) => {
  const date = new Date(dateString);
  date.setDate(date.getDate() - days);
  return date.toISOString().split('T')[0];
};